import React, { useEffect, useRef } from 'react';

import { Trans } from '@lingui/react/macro';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@repo/videa-components/src/ui/dialog';

export const HubSpotForm: React.FC = () => {
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Load HubSpot script if not already loaded
    const loadHubSpotScript = () => {
      return new Promise<void>((resolve) => {
        if (window.hbspt) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/embed/developer/7124858.js';
        script.async = true;
        script.defer = true;

        script.onload = () => {
          resolve();
        };

        script.onerror = () => {
          resolve(); // Resolve anyway to prevent hanging
        };

        document.head.appendChild(script);
      });
    };

    // Initialize form after script is loaded
    const initializeForm = async () => {
      await loadHubSpotScript();

      if (!formRef.current || !window.hbspt) {
        return;
      }

      // Create the form with hardcoded values
      window.hbspt.forms.create({
        region: 'na1',
        portalId: '7124858',
        formId: '39f068e1-2e77-4a08-b8fa-5dad1127ff39',
        target: formRef.current,
      });
    };

    initializeForm();
  }, []);

  return (
    <div
      ref={formRef}
      data-testid="hubspot-form-container"
      className="hs-form-html vai-w-full"
      data-region="na1"
      data-form-id="39f068e1-2e77-4a08-b8fa-5dad1127ff39"
      data-portal-id="7124858"
    />
  );
};

interface HubSpotFormModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const HubSpotFormModal: React.FC<HubSpotFormModalProps> = ({
  open,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="vai-max-w-[80vw] vai-max-h-[80vh] vai-overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            <Trans>Contact Support</Trans>
          </DialogTitle>
        </DialogHeader>
        <div className="vai-p-4">
          <HubSpotForm />
        </div>
      </DialogContent>
    </Dialog>
  );
};

// Add HubSpot types to window object
declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (config: {
          region: string;
          portalId: string;
          formId: string;
          target: HTMLElement;
          onFormReady?: () => void;
          onFormSubmit?: (form: any) => void;
        }) => void;
      };
    };
  }
}
